import { transformCoordinates } from '@/utils/seatSelection';
import React from 'react';
import { Group } from 'react-konva';

export interface BaseElementProps {
  coordinates?: { x?: number; y?: number } | null;
  canvasHeight: number;
  xOffset?: number;
  yOffset?: number;
  isInteractable?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const BaseElement: React.FC<
  BaseElementProps & { children: React.ReactNode }
> = ({
  coordinates,
  canvasHeight,
  xOffset = 0,
  yOffset = 0,
  isInteractable = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children,
}) => {
  const coords = transformCoordinates(
    (coordinates?.x ?? 0) + xOffset,
    (coordinates?.y ?? 0) + yOffset,
    canvasHeight
  );

  return (
    <Group
      x={coords.x}
      y={coords.y}
      onClick={() => {
        if (isInteractable && onClick) {
          onClick();
        }
      }}
      onTap={() => {
        if (isInteractable && onClick) {
          onClick();
        }
      }}
      onMouseEnter={() => {
        if (isInteractable && onMouseEnter) {
          onMouseEnter();
        }
      }}
      onMouseLeave={() => {
        if (onMouseLeave) {
          onMouseLeave();
        }
      }}
      listening={isInteractable}
    >
      {children}
    </Group>
  );
};

export default BaseElement;
